import React from 'react';
import PropTypes from 'prop-types';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import Icon from '@hydra/common/components/Icon';

import CriteriumTable from '@hydra/common/criterium/CriteriumTable';
import Criterium from '@hydra/common/criterium/Criterium';
import ReviewSkeleton from '@hydra/common/components/ReviewSkeleton';

export const DifferenceIcon = ({ difference }) => {
  if (difference === 0) {
    return <Icon type='blank' color='grey' size='xs' />;
  }

  return (difference > 0)
    ? <Icon type='triangle-up' size='xs' color='success' />
    : <Icon type='triangle-down' size='xs' color='error' />;
};

DifferenceIcon.propTypes = {
  difference: PropTypes.number
};

export const PjGaSourceDomains = ({ criterium }) => {
  const { numeral } = useI18n();

  if (!criterium) {
    return (
      <Criterium criterium={{ type: 'pj_ga_source_domains', score: null, importance: 0, solvability: 0 }} clickable={false}>
        <ReviewSkeleton height={451} />
      </Criterium>
    );
  }

  const { data } = criterium;

  if (!data) {
    return null;
  }

  const tableClasses = {
    head: ['', 'alignRight'],
    body: ['', 'alignRight']
  };

  const headings = [
    <Translate content='pj_ga_source_domains' key='pj_ga_source_domains' />,
    <Translate content='pj_ga_val' key='pj_ga_val' />
  ];

  const sortSourceDomains = (a, b) => {
    return data[b].count - data[a].count;
  };

  const rows = Object.keys(data).sort(sortSourceDomains).reduce(
    (rows, title) => {
      rows.push(
        [
          <span key={title}>{title}</span>,
          <span key={data[title].count}>
            {numeral(data[title].count).format()}
            {' '}
            <DifferenceIcon difference={data[title].difference} />
          </span>
        ]
      );
      return rows;
    },
    []
  );

  const content = (
    <div>
      <CriteriumTable
        classNames={tableClasses}
        head={headings}
        rows={rows}
        showAmount={10}
        thinHead
        striped
        nowrap
      />
    </div>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

PjGaSourceDomains.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      viewId: PropTypes.string,
      accessToken: PropTypes.string
    })
  })
};

export default React.memo(PjGaSourceDomains);
